import React from 'react'
import LinkToText from '@components/ContentItem/LinkToText'


const TextOnly = ({ item }) => {
  if(item.data.has_text_only_version){
    let path = "/Division/Research/Documents/" + item.data.text_only_file_name;
    return (
      <LinkToText contentItemPath={path}/>
    )
  }
  else  {
    return (
      <p>
          We are pleased to make reasonable accommodations for members of the public with a disability. For assistance, please contact us at <a href="mailto:research@lcb.state.nv.us" style={{fontSize: '0.85rem', wordWrap: 'break-word'}}>Research@lcb.state.nv.us</a> or call (775) 684-6825.
      </p>
    )
  }
}

export default TextOnly;